// extracted by mini-css-extract-plugin
export default {"product_card":"Product_product_card__E3pYa"};